export default "https://cdn-static.gokick.com/assets/7f5563240f0a87948aacfb3375d791c4357d9b8c/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";